/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PricingScheduleDto } from "./PricingScheduleDto";
import {
    PricingScheduleDtoFromJSON,
    PricingScheduleDtoFromJSONTyped,
    PricingScheduleDtoToJSON,
} from "./PricingScheduleDto";

/**
 *
 * @export
 * @interface PricingSchedulesResponse
 */
export interface PricingSchedulesResponse {
    /**
     *
     * @type {Array<PricingScheduleDto>}
     * @memberof PricingSchedulesResponse
     */
    items?: Array<PricingScheduleDto>;
}

/**
 * Check if a given object implements the PricingSchedulesResponse interface.
 */
export function instanceOfPricingSchedulesResponse(
    value: object,
): value is PricingSchedulesResponse {
    return true;
}

export function PricingSchedulesResponseFromJSON(
    json: any,
): PricingSchedulesResponse {
    return PricingSchedulesResponseFromJSONTyped(json, false);
}

export function PricingSchedulesResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PricingSchedulesResponse {
    if (json == null) {
        return json;
    }
    return {
        items:
            json["items"] == null
                ? undefined
                : (json["items"] as Array<any>).map(PricingScheduleDtoFromJSON),
    };
}

export function PricingSchedulesResponseToJSON(
    value?: PricingSchedulesResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        items:
            value["items"] == null
                ? undefined
                : (value["items"] as Array<any>).map(PricingScheduleDtoToJSON),
    };
}
